import unfetch from 'unfetch'

import storage from 'utils/storage'
import { checkAuth } from 'utils/auth'

const authHeaders = () => ({
  credentials: 'include',
  headers: { Authorization: `Bearer ${storage.getToken()}` }
})

const metadata = (method, data, headers = {}) => ({
  method,
  body: JSON.stringify(data),
  headers: { 'Content-Type': 'application/json', ...headers }
})

const authMetadata = (method, data) => ({
  ...metadata(method, data, { Authorization: `Bearer ${storage.getToken()}` }),
  credentials: 'include'
})

const authFetch = url => checkAuth() ? unfetch(url, authHeaders()) : unfetch(url)

const authRequest = (method, url, body) =>
  unfetch(url, (checkAuth() ? authMetadata : metadata)(method, body))

const json = res => res.ok
  ? res.json().then(d => d).catch(() => res.status)
  : Promise.reject(new Error(res.statusText))

export default {
  get: url => authFetch(url).then(json),
  ...['delete', 'post', 'put'].reduce((acc, method) => ({
    ...acc,
    [method]: (url, body) => authRequest(method, url, body).then(json)
  }), {})
}
